import styles from './lanuguagePopup.scss';
import React from 'react';
import { getLocalizedStrings } from '../../profileSettingsLocalizedStrings';
 
function ProfileLanguagePopup(props){

    let strings = getLocalizedStrings('GeneralSettings');
    let showNormalView = <div className={styles.popUp}>
                            <div className={styles.popupContent}>
                            <div className={styles.AlertHeading}>{strings.languagePopupInfo}</div>  
                            </div>
                         </div>;

    let showEditView = <div className={styles.editPopUp}>
                            <div className={styles.editPopupContent}>
                            <div className={styles.AlertHeading}>{strings.languagePopupInfo}</div>  
                            </div>
                       </div>;
    
    let viewToShow = props.editView ? showEditView : showNormalView;
    return (
        <div>
            {viewToShow}
        </div>
    );
}
 
export default ProfileLanguagePopup;